import './MarIaSideBar.css';

import { Box, IconButton, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useLoginContext } from '../../App';
import Banner from '../b2b-common/Banner';
import Frame from '../b2b-common/Frame';
import B2BButtonGroup from '../b2b-common/B2BButtonGroup';
import { fetchB2BMarIaChatAnswer } from '../../services/b2b-mar-ia-apiService';
import MarIaAnswer from './MarIaAnswer';
import useAccessControl from '../b2b-users/hooks/useAccessControl';
import { ReactComponent as MarIaIcon } from '../../resources/icons/mar-ia.svg';
import MariaQuestion from './MariaQuestion';

const MarIaSideBar = () => {

    const {
        marIaSideBarOpen, setMarIaSideBarOpen,
        sidebarOpen, setSidebarOpen,
        loginData
    } = useLoginContext();

    const [question, setQuestion] = useState('');
    const [answers, setAnswers] = useState([]);
    const [currentAnswer, setCurrentAnswer] = useState('');
    const [toBeRendered, setToBeRendered] = useState(false);
    const [qAndAs, setQAndAs] = useState([]);
    const [isGeneratingAnswer, setIsGeneratingAnswer] = useState(false);
    const [currentQuestionBeingProcessed, setCurrentQuestionBeingProcessed] = useState('');

    useEffect(() => {
        // console.log('Q&As:', qAndAs);
        // console.log('isGeneratingAnswer:', isGeneratingAnswer);
        if (currentAnswer && qAndAs.length > 0 && isGeneratingAnswer) {
            setQAndAs(prevQAndAs => {
                const lastQAndA = { ...prevQAndAs[prevQAndAs.length - 1], answer: currentAnswer };
                return [...prevQAndAs.slice(0, -1), lastQAndA];
            });
            setCurrentQuestionBeingProcessed(''); // Reset the current question being processed
            //console.log('Q&As:', qAndAs);
        }
    }, [isGeneratingAnswer, currentAnswer, currentQuestionBeingProcessed]);

    const { checkAccess } = useAccessControl(
        [
            {
                productsRequired: ['B2B_MARIA'],
                rolesRequired: ['ADMIN', 'EDITOR']
            },
            {
                rolesRequired: ['SUPER_ADMIN', 'SUPER_EDITOR']
            }
        ]
    );

    useEffect(() => {
        setToBeRendered(checkAccess());
    }, [loginData, checkAccess]);

    if (!toBeRendered) {
        return null;
    }

    const transformQAndAToMessages = (qAndAArray) => {
        const messages = qAndAArray.reduce((acc, item) => {
            // Add the question part as a user role
            acc.push({
                role: "user",
                content: item.question
            });
            // Add the answer part as an assistant role, if it exists
            if (item.answer) {
                acc.push({
                    role: "assistant",
                    content: item.answer
                });
            }
            return acc;
        }, []);

        return { messages };
    };

    //const getMessagesDTO = (messages) => {


    const handleSendQuestion = (question) => {
        const updatedQAndAs = [...qAndAs, { question: question, answer: '' }];
        //console.log('Q&As:', updatedQAndAs);
        setQAndAs(prevQAndAs => updatedQAndAs);
        setCurrentQuestionBeingProcessed(question); // Update the current question being processed
        setCurrentAnswer('');
        try {
            //fetchB2BMarIaGenerateAnswer(question, loginData.accessToken, setCurrentAnswer, setIsGeneratingAnswer);
            const messagesDTO = transformQAndAToMessages(updatedQAndAs);
            //console.log('Messages DTO:', messagesDTO);
            fetchB2BMarIaChatAnswer(messagesDTO, loginData.accessToken, setCurrentAnswer, setIsGeneratingAnswer);
            setQuestion('');
        } catch (error) {
            console.error('Failed to fetch Mar·Ia answer:', error);
        }
    }

    return (
        <Box className={`b2b-mar-ia-sidebar ${marIaSideBarOpen ? 'mar-ia-extended' : 'mar-ia-closed'}`}>
            <div className="b2b-mar-ia-sidebar-icon">
                <IconButton onClick={() => {
                    setMarIaSideBarOpen(!marIaSideBarOpen);
                    if (!marIaSideBarOpen && sidebarOpen) {
                        setSidebarOpen(false);
                    }
                }}>
                    <MarIaIcon />
                </IconButton>
            </div>
            {marIaSideBarOpen && (
                <div className="b2b-mar-ia-sidebar-chat-container">
                    <Banner message='Mar·Ia' className={'mar-ia-banner'} />
                    <div className="b2b-mar-ia-sidebar-chat">
                        <TextField
                            id="outlined-multiline-flexible"
                            multiline
                            label="Question"
                            variant="outlined"
                            value={question}
                            rows={4}
                            InputProps={{
                                style: {
                                    fontSize: '0.9rem',
                                },
                            }}
                            className='b2b-mar-ia-chat-input'
                            onChange={(e) => setQuestion(e.target.value)}
                        />
                        <B2BButtonGroup className='b2b-mar-ia-chat-question-buttons'
                            buttonConfigs={[
                                {
                                    label: 'Send', variant: 'contained', color: 'primary',
                                    onClick: () => handleSendQuestion(question)
                                },
                                {
                                    label: 'Clear', variant: 'outlined', color: 'secondary',
                                    onClick: () => {
                                        setQuestion('');
                                        setCurrentAnswer('');
                                        setQAndAs([]);
                                    }
                                }
                            ]}
                        />
                        <Frame title='Q&A' className={'b2b-mar-ia-answers'}>
                            {[...qAndAs].reverse().map((qAndA, index) => (
                                <React.Fragment key={index}>
                                    <MarIaAnswer answer={qAndA.answer} />
                                    <MariaQuestion question={qAndA.question} />
                                </React.Fragment>
                            ))}
                        </Frame>
                    </div>
                </div>
            )}
        </Box>
    );
}

export default MarIaSideBar;